import { render, staticRenderFns } from "./pegawai.vue?vue&type=template&id=930b1126"
import script from "./pegawai.vue?vue&type=script&lang=js"
export * from "./pegawai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports